
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '../../../lib/abpbase'
    class Edithandlereturn {
        id: number;
        returnNo: string;
        returnExpressCompany: string;
        //expressCost: number;
        constructor() {
           
            this.returnExpressCompany = null;
        }

    }
    @Component
    export default class ReturnHandleModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        handlereturn: Edithandlereturn = new Edithandlereturn();
        submit() {
            this.save();
        }
        returnModel() {
            if (this.handlereturn.returnNo.length > 2) {
                var kuaidiNumber;
                if (this.handlereturn.returnNo.substring(0, 2) == "77") {

                    kuaidiNumber = "申通快递";
                }
                if (this.handlereturn.returnNo.substring(0, 2) == "55") {
                    kuaidiNumber = "百世快递";
                }
                if (this.handlereturn.returnNo.substring(0, 2) == "78") {
                    kuaidiNumber = "中通快递";
                }
                if (this.handlereturn.returnNo.substring(0, 1) == "4") {
                    kuaidiNumber = "韵达快递";
                }
                this.handlereturn.returnExpressCompany = kuaidiNumber;
            }
        }
        save() {
            (this.$refs.ReturnHandleForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'returnrejection/editConfirmReturn',
                        data: this.handlereturn
                    });
                    (this.$refs.ReturnHandleForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        cancel() {
            (this.$refs.ReturnHandleForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                var data = this.$store.state.returnrejection.confirmReturnInfo;
                this.handlereturn.id = data.id;
            }
        }
        
        


        returnhandleRule = {
            returnNo: [
                { required: true, max: 30, message: '退货单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            returnExpressCompany: [
                { required: true, max: 30, message: '快递公司不能为空', trigger: 'blur' }
            ],
        };

    }
